import { css } from 'styled-components';

const CAPTURE_ATTRIBUTE = 'data-capture';
export const CAPTURE_HIDE = 'hide';
export const CAPTURE_KEEP = 'keep';

const KEEP = `[${CAPTURE_ATTRIBUTE}='${CAPTURE_KEEP}']`;
const HIDE = `[${CAPTURE_ATTRIBUTE}='${CAPTURE_HIDE}']`;

export const captureModeControlStyles = css`
  & button,
  & [role='button'] {
    visibility: hidden;
  }

  & button${KEEP}, & ${KEEP} button, & ${KEEP} [role='button'] {
    visibility: visible;
  }

  & ${HIDE}, & ${HIDE} * {
    visibility: hidden;
  }

  & ${KEEP} ${HIDE}, & ${KEEP} ${HIDE} * {
    visibility: hidden;
  }
`;
